<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          <!-- <div class="body-content">
            <div class="deduct-amount">
              <p>
                提成总金额：
                <span class="money">{{ setDeductAmount }}</span>
              </p>
              <p class="body-title" @click="addDeductStaffList">
                <i class="el-icon-plus"></i>添加选项
              </p>
            </div>
            <div class="boxs">
              <div class="box" v-for="(item,index) in deductStaffList" :key="index">
                <div class="flex">
                  <div class="staffs-msg">
                    <p class="label">技师：{{ item.staffName }}</p>
                    <div class="staff-name">
                      <el-button
                        class="staff-btn ml10"
                        type="primary"
                        plain
                        @click="setStaff(item,index)"
                      >选择技师</el-button>
                      <div @click="setStaff(item,index)"></div>
                    </div>
                  </div>
                  <div class="deduct-msg">
                    <p class="label">提成：</p>
                    <div class="deduct-name">
                      <el-input
                        placeholder="请输入金额"
                        v-model.trim="item.deductAmount"
                        style="width:133px;"
                      ></el-input>
                    </div>
                  </div>
                </div>
                <div class="close">
                  <i class="el-icon-circle-close" @click="removeDeductStaffList(index)"></i>
                </div>
              </div>
            </div>
          </div>-->
          <p class="title">订单明细</p>
          <div class="totals-box">
            <div class="detail">
              <div class="customTable">
                <div class="box" v-for="(item,index) in form.orderItemVOList" :key="index">
                  <div class="itemName">{{ item.itemName }}</div>
                  <div class="item-else">
                    <div class="itemNum">*{{ item.itemNum }}</div>
                    <div class="money">￥{{ item.realPayAmount }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="drawer-footer">
            <div class="back el-icon-back" @click="back"></div>
            <div>
              <el-button type="primary" class="ml10 small-btn" @click="saveDeduct">保存</el-button>
              <el-button class="ml10 small-btn" @click="saveDeduct">返回</el-button>
            </div>
          </div>
        </div>
      </div>
    </drawer>
    <Dialog
      title="修改提成"
      :hide="updateDeductHide"
      @handleClick="updateDeductHide = false"
      class="dialog-staff-box"
    >
      <div slot="header">修改提成</div>
      <div slot="body">
        <div class="body-content">
          <div class="deduct-amount">
            <p>
              提成总金额：
              <span class="money">{{ setDeductAmount }}</span>
            </p>
            <p class="body-title" @click="addDeductStaffList">
              <i class="el-icon-plus"></i>添加选项
            </p>
          </div>
          <div class="boxs">
            <div class="box" v-for="(item,index) in deductStaffList" :key="index">
              <div class="flex">
                <div class="staffs-msg">
                  <p class="label">技师：{{ item.staffName }}</p>
                  <div class="staff-name">
                    <el-button
                      class="staff-btn ml10"
                      type="primary"
                      plain
                      @click="setStaff(item,index)"
                    >选择技师</el-button>
                    <div @click="setStaff(item,index)"></div>
                  </div>
                </div>
                <div class="deduct-msg">
                  <p class="label">提成：</p>
                  <div class="deduct-name">
                    <el-input
                      placeholder="请输入金额"
                      v-model.trim="item.deductAmount"
                      style="width:133px;"
                    ></el-input>
                  </div>
                </div>
              </div>
              <div class="close">
                <i class="el-icon-circle-close" @click="removeDeductStaffList(index)"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="flex flex-row">
          <div class="mt10">
            <el-button class="ml10 large-btn" @click="saveDeduct">返回</el-button>
          </div>
        </div>
      </div>
    </Dialog>
    <staff-set ref="staffSetForm" @staffChange="changePage"></staff-set>
    <staff-set ref="deductSetForm" @staffChange="changeDeductPage"></staff-set>
    <pay-success ref="paySuccessForm" @change="handleChangePay"></pay-success>
    <payDialog title="核销订单" :hide="dialogHide" @changeDialog="savePay"></payDialog>
  </div>
</template>

<script>
import minxin from "../../assets/javascript/minxin.js";
import drawer from "../../components/common/drawer";
import payDialog from "..//components/pay-dialog";
import staffSet from "../components/staff-set";
import deductSet from "../components/staff-set";

import paySuccess from "./pay-success";

import Dialog from "../../components/common/dialog.vue";
import { decrypt, encrypt } from "../../assets/javascript/untils";
export default {
  mixins: [minxin],
  components: { drawer, payDialog, staffSet, Dialog, paySuccess, deductSet },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "提成信息",
      refundHide: false,
      refundForm: {},
      orderInvalidHide: false,
      orderInvalidForm: {},
      textareaValue: "",
      textareaShow: true,
      textareaDivShow: false,
      merchantAppMemberVO: {},
      form: {},
      dialogHide: false,
      updateDeductHide: false, //修改提成
      setDeductAmount: 0,
      deductStaffList: [
        {
          deductAmount: null,
          staffName: "",
          staffId: ""
        }
      ], //提成列表
      orderForm: {}
    };
  },
  created() {
    this.init();
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("payMobile"))) {
      let arr = JSON.parse(localStorage.getItem("payMobile"));
      if (arr.path == this.$route.path) {
        this.$refs["paySuccessForm"].$emit("set", arr);
      }
    }
  },
  methods: {
    //  页面初始化函数
    handleChangePay(org) {
      if (org) {
        this.$api
          .get(this.$url.orderInfo.get, {
            id: org
          })
          .then(res => {
            if (res) {
              this.addEditShow = true;
              this.form = res;
              this.form.orderTime = this.formatDate(this.form.orderTime);
              this.form.payTime = this.formatDate(this.form.payTime);
              this.form.oxCtime = this.formatDate(this.form.oxCtime);
              this.merchantAppMemberVO = this.form.orderMemberVO;
              //this.merchantAppMemberVO = this.form.merchantAppMemberVO;
            }
          })
          .catch(error => {});
      }
    },
    init() {
      this.$on("set", function(org) {
        this.$api
          .get(this.$url.orderInfo.get, {
            id: org
          })
          .then(res => {
            if (res) {
              this.addEditShow = true;
              this.form = res;
              this.form.orderTime = this.formatDate(this.form.orderTime);
              this.form.payTime = this.formatDate(this.form.payTime);
              this.form.oxCtime = this.formatDate(this.form.oxCtime);
              this.merchantAppMemberVO = this.form.orderMemberVO;
              //this.merchantAppMemberVO = this.form.merchantAppMemberVO;
            }
          })
          .catch(error => {});
      });
    },
    handleChangeDrawer() {
      this.addEditShow = false;
      this.$emit("change", true);
    },
    saveDeduct() {
      if (this.deductStaffList.length <= 0) {
        this.$message.warning("请添加提成");
        return false;
      }
      for (let i in this.deductStaffList) {
        if (this.deductStaffList[i].staffName == "") {
          this.$message.warning("请选择技师");
          return false;
        }
        if (this.deductStaffList[i].deductAmount == "") {
          this.$message.warning("请输入金额");
          return false;
        }
        if (this.deductStaffList[i].deductAmount < 1) {
          this.$message.warning("输入金额不能为0");
          return false;
        }
      }
      let arr = {
        orderId: this.form.id,
        millisecond: new Date().getTime(),
        deductStaffList: this.deductStaffList
      };
      // encrypt(JSON.stringify(arr))
      this.$api
        .post(this.$url.orderInfo.updateDeduct, encrypt(JSON.stringify(arr)))
        .then(res => {
          if (res) {
            this.updateDeductHide = false;
            this.addEditShow = false;
            this.$message.success("操作成功");
            this.$emit("change", true);
          }
        });
    },
    addDeductStaffList() {
      this.deductStaffList.unshift({
        deductAmount: null,
        staffName: "",
        staffId: ""
      });
    },
    removeDeductStaffList(index) {
      this.deductStaffList.splice(index, 1);
    },
    setStaff(item, index) {
      this.$refs["deductSetForm"].$emit("set", {
        single: true,
        staffIds: item.staffId,
        index: index
      });
    },
    changeDeductPage(org) {
      this.deductStaffList[org.nodeId].staffId = org.staffIds[0].staffId;
      this.deductStaffList[org.nodeId].staffName = org.staffIds[0].staffName;
    },
    selectedStaffs(row, index) {
      let arr = [];
      if (row.saleStaffIds) {
        let obj = row.saleStaffIds.split(",");
        for (let i in obj) {
          arr.push({ staffId: obj[i] });
        }
      }
      this.$refs["staffSetForm"].$emit("set", {
        staffIds: arr,
        index: index
      });
    },
    changePage(org) {
      //value
      this.form.orderItemVOList[org.nodeId].saleStaffIds = "";
      this.form.orderItemVOList[org.nodeId].staffNames = "";
      for (let i in org.staffIds) {
        this.form.orderItemVOList[org.nodeId].saleStaffIds +=
          i == 0 ? org.staffIds[i].staffId : "," + org.staffIds[i].staffId;
        this.form.orderItemVOList[org.nodeId].staffNames +=
          i == 0 ? org.staffIds[i].staffName : "," + org.staffIds[i].staffName;
      }
    },
    cashierCancel() {
      //取消订单
      this.$confirm("确定要取消订单吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          let arr = { orderId: this.form.id, cancelReason: "" };
          this.$api
            .post(this.$url.orderInfo.cancel, encrypt(JSON.stringify(arr)))
            .then(res => {
              if (res) {
                this.addEditShow = false;
                this.$message.success("操作成功");
                this.$emit("change", true);
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    handleInvalChange(status) {
      //作废审核
      this.$confirm(status == "pass" ? "确定同意吗?" : "确定拒绝吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          this.$api
            .get(this.$url.orderInfo.audit, {
              id: this.orderInvalidForm.id,
              auditStatus: status
            })
            .then(res => {
              if (res) {
                this.$router.push("/orderInvalid");
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    cashierPay() {
      //继续收银
      this.$refs["paySuccessForm"].$emit("set", this.form);
    },
    cashierWaitExtract() {
      //待取货
      for (let i in this.form.orderItemVOList) {
        if (
          this.form.orderItemVOList[i].saleStaffIds == null ||
          this.form.orderItemVOList[i].saleStaffIds == ""
        ) {
          this.$message.warning("订单明细-请选择技师");
          return false;
        }
      }
      this.dialogHide = true;
    },
    cashierWaitConsume() {
      //待消费
      for (let i in this.form.orderItemVOList) {
        if (
          this.form.orderItemVOList[i].saleStaffIds == null ||
          this.form.orderItemVOList[i].saleStaffIds == ""
        ) {
          this.$message.warning("请选择技师");
          return false;
        }
      }
      this.dialogHide = true;
    },
    savePay(value) {
      if (value != "") {
        let orderItemList = [];
        if (this.form.orderStatus == "waitConsume") {
          for (let i in this.form.orderItemVOList) {
            orderItemList.push({
              itemId: this.form.orderItemVOList[i].itemId,
              itemType: this.form.orderItemVOList[i].itemType,
              staffIds: this.form.orderItemVOList[i].saleStaffIds
            });
          }
        }
        let arr = {
          orderId: this.form.id,
          verifyCode: value.verifyCode,
          payCheckType: value.payCheckType,
          orderItemList: orderItemList
        };
        this.$api
          .post(this.$url.orderInfo.useConfirm, encrypt(JSON.stringify(arr)))
          .then(res => {
            if (res) {
              this.dialogHide = false;
              this.addEditShow = false;
              this.$message.success("操作成功");
              this.$emit("change", true);
            }
          })
          .catch(error => {});
      } else {
        this.dialogHide = false;
      }
    },
    updateDeduct() {
      this.setDeductAmount = 0;
      this.updateDeductHide = true;
      for (let i in this.form.achievementVOList) {
        this.setDeductAmount += this.form.achievementVOList[
          i
        ].deductTotalAmount;
      }
    },
    back() {
      this.addEditShow = false;
      this.$emit("change", true);
    },

    orderInvalid() {},
    // 上传组件成功回调
    // 保存
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$api.post(this.$url.orderInfo.save, this.form).then(res => {
            if (res) {
              this.$api.success();
            }
          });
        }
      });
    }
  }
};
</script>
<style>
.payway-success .el-button + .el-button {
  margin-left: 0;
}
</style>
<style scoped lang="less">
@import "../../assets/css/edit.less";
/deep/ div .el-drawer__body {
  padding: 0 !important;
}
.pay-mains {
  border-top: 10px solid @borderColor;
  border-bottom: 10px solid @borderColor;
  height: 100%;
  box-sizing: border-box;
  .titles-head {
    border-top: 0;
  }
  .totals-box {
    // padding: 0.2rem 0;
    .customTable {
      .box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 72px;
        padding: 15px 26px;
        box-sizing: border-box;
        color: #8d8d8d;
        border-bottom: 1px solid @borderColor;
        .item-else {
          display: flex;
        }
        .money {
          margin-left: 60px;
          color: @money;
        }
      }
    }
    .detail {
      padding: 0;
      font-size: 1rem;
      .rows {
        margin-bottom: 0.2rem;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        p {
          &:first-child {
            min-width: 90px;
          }
          &:last-child {
            text-align: right;
          }
        }
        .amount {
          font-size: 0.3rem;
        }
        div {
          color: #ff892a;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  .order-title-boxs {
    border-top: 10px solid @borderColor;
  }
  .order-boxs {
    .customTable {
      .box {
        height: 46px;
        .decoration {
          text-decoration: line-through;
        }
        .itemNum {
          font-size: 18px;
        }
        .itemName {
          color: #333;
        }
      }
    }
  }
  .org-title {
    border-top: 10px solid @borderColor;
  }
  .pay-methods {
    padding: 0.3rem;
    .methods {
      margin-right: 0.2rem;
      width: 138px;
      height: 108px;
      background-color: #ececed;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .imgs {
        margin-bottom: 0.1rem;
        width: 30px;
        height: 30px;
      }
    }
    .active {
      background-image: url("../../assets/images/money/gou.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-color: @blue;
    }
  }
}
.dialog-staff-box {
  .body-content {
    .deduct-amount {
      display: flex;
      justify-content: space-between;
      margin: 0 30px;
      font-size: 16px;

      .money {
        color: #f40;
      }
    }
    .body-title {
      text-align: right;
      color: #2795fd;
      cursor: pointer;
      i {
        margin-right: 9px;
      }
    }
    .boxs {
      margin: 0 29px;
      font-size: 16px;
      .box {
        margin-top: 20px;
        background-color: #f3f3f3;
        border-radius: 4px;
        color: #282828;
        display: flex;
        align-items: center;
        .flex {
          flex: 1;
          margin-right: 42px;
          .staffs-msg {
            padding-top: 20px;
            display: flex;
            justify-content: space-between;
            // align-items: center;
            .img {
              cursor: pointer;
            }
            .staff-name {
              display: flex;
              align-items: center;
            }
            .add-img {
              width: 35px;
              vertical-align: middle;
              position: relative;
              &::before {
                content: "+";
                position: absolute;
                font-size: 24px;
                height: 35px;
                top: 0;
                left: 0;
                width: 35px;
                text-align: center;
              }
            }
            .notStaff {
              position: relative;
              background-size: 100% 100%;
              background-repeat: no-repeat;
              width: 133px;
              height: 33px;
              cursor: pointer;
              display: flex;
              justify-content: center;
              .span {
                left: 45px;
                position: absolute;
                height: 33px;
                display: flex;
                align-items: center;
                &::before {
                  content: "+";
                  font-size: 24px;
                  position: absolute;
                  left: -20px;
                  color: #333;
                  height: 35px;
                  top: 0;
                }
              }
            }
          }
          .deduct-msg {
            padding: 20px 0;
            display: flex;
            justify-content: space-between;
          }
          .label {
            margin-left: 26px;
          }
        }
        .close {
          margin-right: 20px;
          font-size: 25px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>